import { AxiosPromise } from 'axios';
import { axios } from '../axios';
import { IStoreProduct } from './types';
import { getSearchFilter } from '../../app/utils';

export const getProducts = (
  query: { siteId: string, searchString: string }
): AxiosPromise<IStoreProduct[]> => {
  return axios.get(`/stock?siteId=${query.siteId}&withProductSummary=1${getSearchFilter(query.searchString, "q")}`);
}

export const placeOrder = (siteId: number, systemId: number, products: IStoreProduct[]) => {
  const order = {
    siteId,
    systemId,
    products: products.map(product => ({
      productId: product.productId,
      quantity: product.inOrder
    }))
  }
  return axios.post(`/orders`, order);
}
